import script from "./LoaderView.vue?vue&type=script&setup=true&lang=js"
export * from "./LoaderView.vue?vue&type=script&setup=true&lang=js"

import "./LoaderView.vue?vue&type=style&index=0&id=55ab1bf4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55ab1bf4"]])

export default __exports__